import { atom } from 'jotai'
import * as R from 'remeda'

import { type OverlapGroupFilter } from '~/gql/graphql'
import { compareGroup, exists, type Group } from '~/utils'

import { overlapKeyMap } from '../utils'

import { brand1IdAtom, brand2IdAtom, groupInfosAtom } from './stateAtoms'

export const overlapGroupFiltersAtom = atom<OverlapGroupFilter[]>((get) => {
  const brand1Id = get(brand1IdAtom)
  const brand2Id = get(brand2IdAtom)
  const groupInfos = get(groupInfosAtom)

  if (!exists(brand1Id) || !exists(brand2Id)) {
    return []
  }

  return R.pipe(
    groupInfos,
    R.groupBy(R.prop('group')),
    R.entries(),
    R.map(([group, groupInfos]): OverlapGroupFilter => ({
      brand1: brand1Id,
      brand2: brand2Id,
      group,
      combinations: R.pipe(
        groupInfos,
        R.sortBy(R.prop('brand2')),
        R.sortBy(R.prop('brand1')),
        R.map((groupInfo) => {
          const brand1 = overlapKeyMap[groupInfo.brand1]
          const brand2 = overlapKeyMap[groupInfo.brand2]

          return `${brand1}_x_${brand2}`
        }),
      ),
    })),
    R.sort((a, b) => compareGroup(a.group as Group, b.group as Group)),
  )
})
